"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStr = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function makeStr(repetitionOfChar, baseChar) {
    return Array.prototype.join.call({ length: (repetitionOfChar || -1) + 1 }, baseChar || 'x');
}
exports.makeStr = makeStr;
//# sourceMappingURL=string.js.map